// extracted by mini-css-extract-plugin
var _1 = "Rgv32ZhSYEDlGt51XZIe";
var _2 = "vDvI8ZP0f2e9vxxKFOrM";
var _3 = "O_BGVPfXX9sy7CPH2UX3";
export { _1 as "small", _2 as "spin", _3 as "spinner" }
